import FileActionsMenu from './FileActionsMenu.jsx'
export default FileActionsMenu 